@if (showBreadcrumbNav) {
  <p-breadcrumb class="max-w-full" [model]="items" [home]="home"></p-breadcrumb>
}
